import React from "react";
import { cn } from "../../utils/cn";

export default function Background({ className }: { className?: string }) {
    return (
        <div className={cn("pointer-events-none absolute inset-0 -z-10 overflow-hidden", className)}>
            {/* Base */}
            <div className="absolute inset-0 bg-[#070A12]" />

            {/* Soft gradient */}
            <div className="absolute -top-40 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-white/10 blur-3xl" />
            <div className="absolute -bottom-56 left-10 h-[520px] w-[520px] rounded-full bg-white/5 blur-3xl" />
            <div className="absolute top-1/3 right-10 h-[520px] w-[520px] rounded-full bg-white/5 blur-3xl" />

            {/* Grid */}
            <div
                className="absolute inset-0 opacity-[0.12]"
                style={{
                    backgroundImage:
                        "linear-gradient(to right, rgba(255,255,255,.12) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,.12) 1px, transparent 1px)",
                    backgroundSize: "48px 48px",
                }}
            />

            {/* Vignette */}
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/40" />
        </div>
    );
}
